<header
  class="fixed top-0 right-0 left-0 h-not-auth-header-m md:h-not-auth-header-d z-1000"
>
  <div
    class="max-w-1440px mx-auto px-app-x-m md:px-app-x-d flex justify-between items-center h-full"
  >
    <a [routerLink]="['/']"
      ><ib-logo-name-vertical
        *ngIf="bpS.isMd"
        class="w-50px"
      ></ib-logo-name-vertical>
      <ib-logo-name-horizontal
        *ngIf="!bpS.isMd"
        class="w-220px"
      ></ib-logo-name-horizontal
    ></a>
    <a
      *ngIf="
        currUrl === '/signup' ||
        currUrl === '/forgot-password' ||
        currUrl?.startsWith('/reset-password')
      "
      [routerLink]="LOGIN"
      class="ib-link ib-link-white ml-4"
    >
      Sign In
    </a>
    <a
      *ngIf="currUrl === '/login'"
      [routerLink]="SIGN_UP"
      class="ib-link ib-link-white ml-4"
    >
      Sign Up
    </a>
  </div>
</header>
